import { environmentShared } from './environment.shared';

export const environment = {
    ...environmentShared,
    production: true,
    useOnlyStaticTranslationFiles: false,
    tenantDashboardTitle: null,
    firebaseConfig: {
        apiKey: 'AIzaSyCgsDrTaa-ZAw1OrXp9Wt30nRgEVJzDk9k',
        authDomain: 'cgd-staging-d7378.firebaseapp.com',
        databaseURL: 'https://cgd-staging-d7378.firebaseio.com',
        projectId: 'cgd-staging-d7378',
        storageBucket: 'cgd-staging-d7378.appspot.com',
        messagingSenderId: '129380211754',
        appId: '1:129380211754:web:79f8dc469e9f6685377753',
        region: 'europe-west1',
    },
    metricsConfig: {
        apiUrl: 'https://staging.agentifai.com/metrics-api',
        livePollingInterval: 4,
        refreshInterval: 120,
    },
    twilio: {
        TOKEN_URL: 'https://staging.agentifai.com:23002/api/twilio/token',
        OUTBOUND_REQUEST_URL: 'https://staging.agentifai.com:23002/api/twilio/outboundRequest',
        CONFERENCE_HOLD_URL: 'https://staging.agentifai.com:23002/api/twilio/conference/hold',
        CALL_TRANSFER_URL: 'https://staging.agentifai.com:23002/api/twilio/call/transfer',
        CREATE_CALL_URL: 'https://staging.agentifai.com:23002/api/twilio/call',
    },
    jambonz: {
        socketAddress: 'wss://agentifai.sip.jambonz.us:8443',
        UAConfigurationURI: (clientId: string) => {
            return `sip:${clientId}@jambonz-dev.agentifai.com`;
        },
        STUN_TURN_CONFIG: 'https://staging.agentifai.com:23002/api/stun-turn-configuration',
        REGISTER_USER_URL: 'https://staging.agentifai.com:23002/api/jambonz/register/user',
        UNREGISTER_USER_URL: 'https://staging.agentifai.com:23002/api/jambonz/unregister/user',
        REGISTER_CONFERENCE_URL: 'https://staging.agentifai.com:23002/api/jambonz/conference/operator',
        TOKEN_URL: 'https://staging.agentifai.com:23002/api/jambonz/token',
        OUTBOUND_REQUEST_URL: 'https://staging.agentifai.com:23002/api/jambonz/token/outboundRequest',
        CONFERENCE_HOLD_URL: 'https://staging.agentifai.com:23002/api/jambonz/conference/hold',
        CALL_TRANSFER_URL: 'https://staging.agentifai.com:23002/api/jambonz/call/transfer',
        CREATE_CALL_URL: 'https://staging.agentifai.com:23002/api/jambonz/call',
    },
    dashboardCoreConfig: {
        apiEndpoint: 'https://staging.agentifai.com/',
        retryPolicy: {
            numberOfRetries: 3,
            scaling: 100,
            statusCodes: [500, 404, 403],
        },
    },
};
